import axiosInstance from '../lib/axios';

export interface JobTitle {
  id: string;
  title: string;
  description: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  createdBy: string;
  updatedBy: string;
}

export interface CreateJobTitleRequest {
  title: string;
  description: string;
  isActive?: boolean;
}

export interface UpdateJobTitleRequest {
  title?: string;
  description?: string;
  isActive?: boolean;
}

export interface JobTitleDropdownOption {
  id: string;
  title: string;
  description: string;
}

export interface PaginatedJobTitleResponse {
  data: JobTitle[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

class JobTitleService {
  private baseUrl = '/job-titles';

  async createJobTitle(data: CreateJobTitleRequest): Promise<JobTitle> {
    const response = await axiosInstance.post(`${this.baseUrl}`, data);
    return response.data;
  }

  async getJobTitles(params?: {
    page?: number;
    limit?: number;
    search?: string;
    isActive?: boolean;
  }): Promise<PaginatedJobTitleResponse> {
    const response = await axiosInstance.get(`${this.baseUrl}`, { params });
    return response.data;
  }

  async getJobTitleById(id: string): Promise<JobTitle> {
    const response = await axiosInstance.get(`${this.baseUrl}/${id}`);
    return response.data;
  }

  async updateJobTitle(id: string, data: UpdateJobTitleRequest): Promise<JobTitle> {
    const response = await axiosInstance.patch(`${this.baseUrl}/${id}`, data);
    return response.data;
  }

  async deleteJobTitle(id: string): Promise<void> {
    await axiosInstance.delete(`${this.baseUrl}/${id}`);
  }

  async getJobTitlesForDropdown(): Promise<JobTitleDropdownOption[]> {
    const response = await axiosInstance.get(`${this.baseUrl}/dropdown`);
    return response.data;
  }
}

export const jobTitleService = new JobTitleService();
export default jobTitleService;
